import DesignComp from "../images/flow.png"

const Design = () => {
  const focusAreas = [
    {
      eyebrow: "Collaboration",
      title: "Design & product partner",
      points: [
        "Bridge the gap between design and engineering, fluent in both languages",
        "Hands-on background in mockups, wireframes, layouts, logos & label design",
        "Strong grasp of design principles, accessibility, and user experience",
        "Involved early: planning, scoping, and feasibility conversations",
      ],
    },
    {
      eyebrow: "Leadership",
      title: "Technical design lead",
      points: [
        "Own architecture and technical design for large, multi-team builds",
        "Tech lead and primary point of contact for product & project management",
        "Break complex problems into scalable, maintainable systems",
        "Integrate AI into products and daily dev workflows to ship faster",
        "Mentor engineers and keep eng, product & design aligned",
      ],
    },
  ];

  const craft = ["Wireframing", "Prototyping", "Design systems", "UX / UI", "Photoshop", "Illustrator"];

  return (
    <div id="design" className="container design-section my-5 py-5">
      <div className="d-flex flex-column-reverse flex-lg-row align-items-center mb-5">
        <div className="flex-4 me-lg-5">
          <h1>Design-minded engineering</h1>
          <h3 className="mb-4">the bridge between design &amp; code</h3>
          <p>I'm an engineer who speaks design. Having built mockups, wireframes, and brand work myself, I can sit down with designers and product, translate intent into solid code, and carry the technical direction of large, complex projects from idea to ship, with AI woven into the process to prototype, iterate, and refine faster.</p>
        </div>
        <div className="flex-3">
          <img className="design-image" src={DesignComp} alt="Selection of design work" />
        </div>
      </div>

      <div className="d-flex flex-column flex-lg-row">
        {focusAreas.map((area) => (
          <div className="focus-card flex-1" key={area.title}>
            <span className="focus-eyebrow">{area.eyebrow}</span>
            <h4>{area.title}</h4>
            <ul className="focus-list">
              {area.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="d-flex flex-wrap justify-content-center mt-5">
        {craft.map((c) => (
          <div className="skill-box" key={c}>{c}</div>
        ))}
      </div>
    </div>
  )
}

export default Design
